import React from "react";
import Vote from './commentaire/vote';
import { FaStar } from "react-icons/fa";
import './RadioFilters.css';

let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
const __elakayText = (key, fallback) =>
  __elakayInfoSource?.laguangeElakay?.("frontElakayHardcodedText", __elakayInfoSource.languageAPI)?.["radioboxRating"]?.[key] || fallback;

const RadioboxRating = (props) => {
    const {
        handleFilters,
        allStars,
        infoSource
    } = props;
  __setElakayInfoSource(infoSource);

    const {
        stars1, setStars1,
        stars2, setStars2,
        stars3, setStars3,
        stars4, setStars4,
        stars5, setStars5,
    } = allStars;

    const handleStarChange = (starValue, currentState, setState) => {
        // Reset all stars
        setStars1(false);
        setStars2(false);
        setStars3(false);
        setStars4(false);
        setStars5(false);
        
        // Set current star
        setState(!currentState);
        
        if (!currentState) {
            handleFilters(starValue.toString());
        } else {
            handleFilters("");
        }
    };

    const ratingOptions = [
        { value: 5, state: stars5, setState: setStars5, label: __elakayText("t002", "5 stars and up") },
        { value: 4, state: stars4, setState: setStars4, label: __elakayText("t003", "4 stars and up") },
        { value: 3, state: stars3, setState: setStars3, label: __elakayText("t004", "3 stars and up") },
        { value: 2, state: stars2, setState: setStars2, label: __elakayText("t005", "2 stars and up") },
        { value: 1, state: stars1, setState: setStars1, label: __elakayText("t006", "1 star and up") }
    ];

    return (
        <div className="rating-group-modern">
            {ratingOptions.map((option, index) => (
                <div 
                    key={option.value}
                    className="rating-item-modern"
                    style={{ animationDelay: `${index * 0.05}s` }}
                >
                    <input
                        onChange={() => handleStarChange(option.value, option.state, option.setState)}
                        value={option.value}
                        checked={option.state}
                        name="Stars"
                        type="radio"
                        className="radio-input-modern"
                        id={`stars-${option.value}`}
                    />
                    <label 
                        className="rating-label-modern" 
                        htmlFor={`stars-${option.value}`}
                    >
                        <span className="radio-circle"></span>
                        <div className="rating-content">
                            <Vote rating={option.value} />
                            <span className="rating-up-text">{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).radioboxRating.t001}</span>
                        </div>
                    </label>
                </div>
            ))}
        </div>
    );
};

export default RadioboxRating;